import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@lt/components';
import CurrencyFormat from '../../../../../components/CurrencyFormat';

const ExtraPrice = ({ price, className }) => (
  <Badge primary={price > 0} className={className}>
    <CurrencyFormat value={price} prefix="+ " />
  </Badge>
);

ExtraPrice.propTypes = {
  price: PropTypes.number,
  className: PropTypes.string,
};

ExtraPrice.defaultProps = {
  price: 0,
  className: '',
};

export default ExtraPrice;
